/**
 * After a deploy, a tab opened earlier still asks for the old build's chunk
 * files, which no longer exist. Reload once to pick up the new build instead
 * of showing the error screen. A short guard stops a reload loop if a chunk
 * is genuinely missing.
 */
const RELOAD_KEY = "stale-chunk-reload-at";
const GUARD_MS = 10_000;

export function isStaleChunkError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : String(error ?? "");
  return /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module/i.test(
    message,
  );
}

/** Reloads the page unless it already did so moments ago. Returns true when reloading. */
export function reloadForNewBuild(): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY)) || 0;
    if (Date.now() - last < GUARD_MS) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch {
    return false; // no storage means no loop guard, so don't auto-reload
  }
  window.location.reload();
  return true;
}

window.addEventListener("vite:preloadError", (event) => {
  if (reloadForNewBuild()) event.preventDefault();
});
